import {
	GET_LAST_IMPORT,
	GET_WORK_ORDER_DELTA_TABLE,
	TOGGLE_IMPORT_MODAL_VISIBILITY
} from '../actions/WorkOrderStatusActions.js';

const initialState = {
	lastImport: '',
	workOrderDeltaTableData: [],
	importModalVisibility: false
};

const workOrderStatusReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_LAST_IMPORT: {
						return {
							...state,
							lastImport: action.lastImport
						};
					}
					case GET_WORK_ORDER_DELTA_TABLE: {
						return {
							...state,
							workOrderDeltaTableData: action.workOrderDeltaTableData
						};
					}
					case TOGGLE_IMPORT_MODAL_VISIBILITY: {
						return {
							...state,
							importModalVisibility: action.importModalVisibility
						};
					}
					default: {
						return state;
					}
	}
};

export default workOrderStatusReducer;
